import { Park } from '../models/Park';
import Configuration from '../../global/Configuration';
import HttpClient from '../../global/api/HttpClient';

export const GetParksRequest = async (): Promise<Park[]> => {
  try {
    const response = await HttpClient.get(`${Configuration.CSNMS_BASE_URL}/api/security/parks`);

    return response.data;
  } catch (ex) {
    return [];
  }
};
